var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        _vm.formErrorClass(_vm.name),
        "form-group",
        _vm.floating && "form-group--floating",
      ],
    },
    [
      _vm.floating
        ? [
            _vm._t("default", null, null, { id: _vm.id }),
            _vm._v(" "),
            _vm.label
              ? _c("label", {
                  ref: "label",
                  staticClass: "col-form-label",
                  attrs: { for: _vm.id },
                  domProps: { textContent: _vm._s(_vm.label) },
                })
              : _vm._e(),
          ]
        : [
            _vm.label
              ? _c("label", {
                  ref: "label",
                  staticClass: "col-form-label",
                  attrs: { for: _vm.id },
                  domProps: { textContent: _vm._s(_vm.label) },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm._t("default", null, null, { id: _vm.id }),
          ],
      _vm._v(" "),
      _vm._l(_vm.names, function (_name) {
        return _c("ErrorText", {
          key: _name,
          attrs: { errorContainer: _vm.errorContainer, name: _name },
        })
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }